const {
  v4: uuidv4
} = require("uuid");
/**
 *
 * Gets deviceId from amplitude cookie and stores it in localstorage as segmentDeviceId
 * If there is no cookie it creates a new uuidv4.
 * @returns {string} deviceId
 *
 */
const getSegmentDeviceId = () => {
  try {
    const alreadyInLocalStorage = localStorage.getItem("segmentDeviceId");
    if (alreadyInLocalStorage) {
      return alreadyInLocalStorage;
    }
    const cookie = document.cookie.match(/amplitude_id_[A-Za-z0-9]+mindbodygreen\.com=.+?(?=(=|;))/);
    let cookieValue;
    if (cookie) {
      cookieValue = cookie[0].split("=")[1];
    }
    if (!cookieValue) {
      const newID = uuidv4();
      localStorage.setItem("segmentDeviceId", newID);
      return newID;
    }
    const parsedCookieObject = JSON.parse(atob(cookieValue));
    localStorage.setItem("segmentDeviceId", parsedCookieObject["deviceId"]);
    return parsedCookieObject["deviceId"];
  } catch (error) {
    console.error(error);
  }
};
module.exports = {
  getSegmentDeviceId
};